import PromptVariablesTable from "./components/prompt-variables-table/promptVariablesTables";

const PromptVariablesTables = () => {
  return (
    <div>
      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
        <PromptVariablesTable />
      </div>
    </div>
  );
};

export default PromptVariablesTables;
